<template>
  <div>
    <!-- 全局加载页面 -->
    <div v-if="isPageLoading" class="page-loading-overlay">
      <div class="page-loading-content">
        <div class="page-loading-spinner"></div>
        <p class="page-loading-text">页面加载中...</p>
      </div>
    </div>

    <!-- 进入车队加载效果 -->
    <div v-if="isJoiningCar" class="page-loading-overlay">
      <div class="page-loading-content">
        <div class="page-loading-spinner"></div>
        <p class="page-loading-text">进入车队中...</p>
      </div>
    </div>

    <input id="nav-toggle" type="checkbox" />
    <div v-if="!isPageLoading" class="page">
      <aside class="sidebar">
        <label for="nav-toggle" class="close-btn">×</label>
        <div class="side-box">
          <div v-if="config.siteName || config.siteLogo" class="side-brand">
            <img v-if="config.siteLogo" :src="config.siteLogo" alt="Logo" style="width:24px;height:24px;border-radius:6px;object-fit:cover" />
            <strong v-if="config.siteName">{{ config.siteName }}</strong>
          </div>
        </div>
        <div class="side-box">
          <nav class="nav">
            <div 
              v-if="config.chatgptMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'chatgpt' && !iframeMode && !showProfile }" 
              @click="switchCategory('chatgpt')"
            >
              {{ config.chatgptMenuName }}
            </div>
            <div 
              v-if="config.grokMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'grok' && !iframeMode && !showProfile }" 
              @click="switchCategory('grok')"
            >
              {{ config.grokMenuName }}
            </div>
            <div 
              v-if="config.geminiMenuName"
              class="nav-item" 
              :class="{ active: currentCategory === 'gemini' && !iframeMode && !showProfile }" 
              @click="switchCategory('gemini')"
            >
              {{ config.geminiMenuName }}
            </div>
            <div 
              v-for="menu in customMenus" 
              :key="menu.id" 
              class="nav-item" 
              :class="{ active: iframeMode && currentMenuId === menu.id && !showProfile }"
              @click="openInIframe(menu.url, menu.name, menu.id)"
            >
              {{ menu.name }}
            </div>
            <div 
              v-if="isLoggedIn"
              class="nav-item" 
              :class="{ active: showProfile }"
              @click="openProfile"
            >
              个人中心
            </div>
          </nav>
        </div>
      </aside>

      <label class="drawer-mask" for="nav-toggle"></label>

      <main class="main">
        <div class="page-header">
          <div class="sys">
            <label class="hamburger" for="nav-toggle">☰</label>
            <div class="brand">
              <img v-if="config.siteLogo" :src="config.siteLogo" alt="Logo" style="width:22px;height:22px;border-radius:6px;object-fit:cover" />
              <strong>{{ config.siteName || 'ShareAI' }}</strong>
            </div>
          </div>
          <div class="redeem">
            <!-- 登录用户：显示兑换码按钮、新PLUS站按钮和用户信息 -->
            <template v-if="isLoggedIn">
              <div class="action-buttons">
                <span v-if="config.exchangeName" class="btn-redeem" @click="openExchangeModal">{{ config.exchangeName }}</span>
                <span class="btn-plus" @click="openNewPlusSiteModal">点我前往新PLUS站点</span>
              </div>
              <div class="userpill">
                <div>{{ userInfo.userToken || userInfo.email }}</div>
                <small>{{ currentCategory === 'grok' ? 'Grok' : currentCategory === 'gemini' ? 'Gemini' : 'ChatGPT' }} 有效期 {{ formatExpireTime(currentCategory === 'grok' ? userInfo.grokExpireTime : currentCategory === 'gemini' ? userInfo.geminiExpireTime : userInfo.expireTime) }}</small>
              </div>
            </template>
            
            <!-- 游客：只显示登录按钮 -->
            <template v-else>
              <span class="btn-login" @click="goToLogin">登录</span>
            </template>
          </div>
        </div>

        <div v-if="carNotice && !iframeMode && !showProfile" class="notice box" v-html="carNotice"></div>

        <div v-if="!iframeMode && !showProfile" class="fleet-toolbar box">
          <div class="quick-nav">
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'chatgpt' }" 
              @click="switchCategory('chatgpt')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="18" height="18">
                <path d="M 14.070312 2 C 11.330615 2 8.9844456 3.7162572 8.0390625 6.1269531 C 6.061324 6.3911222 4.2941948 7.5446684 3.2773438 9.3066406 C 1.9078196 11.678948 2.2198602 14.567816 3.8339844 16.591797 C 3.0745422 18.436097 3.1891418 20.543674 4.2050781 22.304688 C 5.5751778 24.677992 8.2359331 25.852135 10.796875 25.464844 C 12.014412 27.045167 13.895916 28 15.929688 28 C 18.669385 28 21.015554 26.283743 21.960938 23.873047 C 23.938676 23.608878 25.705805 22.455332 26.722656 20.693359 C 28.09218 18.321052 27.78014 15.432184 26.166016 13.408203 C 26.925458 11.563903 26.810858 9.4563257 25.794922 7.6953125 C 24.424822 5.3220082 21.764067 4.1478652 19.203125 4.5351562 C 17.985588 2.9548328 16.104084 2 14.070312 2 z M 14.070312 4 C 15.226446 4 16.310639 4.4546405 17.130859 5.2265625 C 17.068225 5.2600447 17.003357 5.2865019 16.941406 5.3222656 L 12.501953 7.8867188 C 12.039953 8.1527187 11.753953 8.6456875 11.751953 9.1796875 L 11.724609 15.146484 L 9.5898438 13.900391 L 9.5898438 8.4804688 C 9.5898438 6.0104687 11.600312 4 14.070312 4 z M 20.492188 6.4667969 C 21.927441 6.5689063 23.290625 7.3584375 24.0625 8.6953125 C 24.640485 9.696213 24.789458 10.862812 24.53125 11.958984 C 24.470201 11.920997 24.414287 11.878008 24.351562 11.841797 L 19.910156 9.2773438 C 19.448156 9.0113437 18.879016 9.0103906 18.416016 9.2753906 L 13.236328 12.236328 L 13.248047 9.765625 L 17.941406 7.0546875 C 18.743531 6.5915625 19.631035 6.4055313 20.492188 6.4667969 z M 7.5996094 8.2675781 C 7.5972783 8.3387539 7.5898438 8.4087418 7.5898438 8.4804688 L 7.5898438 13.607422 C 7.5898438 14.141422 7.8729844 14.635297 8.3339844 14.904297 L 13.488281 17.910156 L 11.34375 19.134766 L 6.6484375 16.425781 C 4.5094375 15.190781 3.7747656 12.443687 5.0097656 10.304688 C 5.5874162 9.3043657 6.522013 8.5923015 7.5996094 8.2675781 z M 18.65625 10.865234 L 23.351562 13.574219 C 25.490562 14.809219 26.225234 17.556313 24.990234 19.695312 C 24.412584 20.695634 23.477987 21.407698 22.400391 21.732422 C 22.402722 21.661246 22.410156 21.591258 22.410156 21.519531 L 22.410156 16.392578 C 22.410156 15.858578 22.127016 15.364703 21.666016 15.095703 L 16.511719 12.089844 L 18.65625 10.865234 z M 15.009766 12.947266 L 16.78125 13.980469 L 16.771484 16.035156 L 14.990234 17.052734 L 13.21875 16.017578 L 13.228516 13.964844 L 15.009766 12.947266 z M 18.275391 14.853516 L 20.410156 16.099609 L 20.410156 21.519531 C 20.410156 23.989531 18.399687 26 15.929688 26 C 14.773554 26 13.689361 25.54536 12.869141 24.773438 C 12.931775 24.739955 12.996643 24.713498 13.058594 24.677734 L 17.498047 22.113281 C 17.960047 21.847281 18.246047 21.354312 18.248047 20.820312 L 18.275391 14.853516 z M 16.763672 17.763672 L 16.751953 20.234375 L 12.058594 22.945312 C 9.9195938 24.180312 7.1725 23.443687 5.9375 21.304688 C 5.3595152 20.303787 5.2105423 19.137188 5.46875 18.041016 C 5.5297994 18.079003 5.5857129 18.121992 5.6484375 18.158203 L 10.089844 20.722656 C 10.551844 20.988656 11.120984 20.989609 11.583984 20.724609 L 16.763672 17.763672 z" fill="currentColor"/>
              </svg>
              GPT
            </button>
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'grok' }" 
              @click="switchCategory('grok')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="18" height="18">
                <path d="M 47.658203 2.0566406 C 47.415078 2.0662656 47.174734 2.1631563 46.990234 2.3476562 L 40.880859 8.4648438 C 40.833859 8.4968438 40.789047 8.5351719 40.748047 8.5761719 L 19.146484 30.304688 C 18.777484 30.675688 18.755656 31.266109 19.097656 31.662109 C 19.440656 32.058109 20.027219 32.1245 20.449219 31.8125 L 35.529297 20.667969 C 35.657297 20.572969 35.818125 20.540172 35.953125 20.576172 C 36.101125 20.617172 36.145156 20.725719 36.160156 20.761719 C 37.941156 25.057719 36.981844 29.949656 33.714844 33.222656 C 30.821844 36.118656 26.849547 37.186391 22.810547 36.150391 C 22.575547 36.090391 22.321516 36.119422 22.103516 36.232422 L 16.794922 38.984375 C 16.467922 39.153375 16.259906 39.489422 16.253906 39.857422 C 16.247906 40.225422 16.445625 40.566094 16.765625 40.746094 C 19.618625 42.341094 22.706953 43.119141 25.751953 43.119141 C 30.372953 43.119141 34.89475 41.326094 38.34375 37.871094 C 42.74375 33.467094 44.536297 27.227297 43.154297 21.154297 C 43.150297 21.114297 43.142812 21.073203 43.132812 21.033203 C 41.376812 13.469203 43.505828 10.537469 48.173828 4.1054688 L 48.507812 3.640625 C 48.813813 3.217625 48.741703 2.6309688 48.345703 2.2929688 C 48.147703 2.1249687 47.901328 2.0470156 47.658203 2.0566406 z M 25.996094 7.1367188 C 21.206724 7.0397839 16.477547 8.8765469 12.935547 12.419922 C 7.8695469 17.492922 6.2917656 25.345937 9.0097656 31.960938 C 10.693766 36.058937 7.9562031 38.935484 4.7832031 42.271484 C 3.6512031 43.460484 2.4804844 44.691719 1.5214844 46.011719 C 1.2224844 46.425719 1.2801563 46.998797 1.6601562 47.341797 C 1.8501562 47.513797 2.0900781 47.599609 2.3300781 47.599609 C 2.5680781 47.599609 2.8080469 47.515703 2.9980469 47.345703 L 17.335938 34.525391 C 17.482938 34.416391 17.599922 34.268797 17.669922 34.091797 C 17.822922 33.712797 17.728594 33.278094 17.433594 32.996094 C 14.748594 30.429094 14.157766 27.483844 14.134766 25.464844 C 14.099766 22.358844 15.354984 19.296453 17.583984 17.064453 C 20.080984 14.562453 23.836578 13.331469 27.392578 13.855469 C 27.595578 13.883469 27.810047 13.850906 27.998047 13.753906 L 33.689453 10.800781 C 34.024453 10.627781 34.232516 10.278391 34.228516 9.9003906 C 34.224516 9.5223906 34.006016 9.1796719 33.666016 9.0136719 C 33.269016 8.8206719 32.857031 8.6362812 32.457031 8.4882812 C 30.361094 7.6242188 28.17308 7.18078 25.996094 7.1367188 z" fill="currentColor"/>
              </svg>
              Grok
            </button>
            <button 
              class="quick-nav-btn" 
              :class="{ active: currentCategory === 'gemini' }" 
              @click="switchCategory('gemini')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor"/>
              </svg>
              Gemini
            </button>
          </div>
          <div class="search">
            <input v-model="searchKeyword" placeholder="实时搜索车队" />
          </div>
        </div>

        <!-- 车队内容容器 -->
        <div v-if="!iframeMode && !showProfile" id="fleetContainer">
          <!-- 加载中状态 -->
          <div v-if="isLoadingCars" class="loading-container">
            <div class="loading-spinner-large"></div>
            <p class="loading-text">正在加载车队数据...</p>
          </div>

          <!-- 车队列表 -->
          <div v-else v-for="category in displayCategories" :key="category.key" class="category-section">
            <div class="category-title">
              <span style="width:10px;height:24px;display:inline-block;flex-shrink:0"></span>
              <span>{{ category.name }}</span>
            </div>
            <div class="fleet-content">
              <div v-for="car in category.cars" :key="car.carID" class="botcard" @click="handleCarClick(car.carID, category.type)">
                <div class="botcard-hd">
                  <span v-html="getCategoryIcon(category.type)"></span>
                  <div class="badge-container">
                    <div class="badge">{{ getBadgeType(car, category.type) }}</div>
                    <div v-if="car.isIQ" class="recommend-badge">推荐</div>
                  </div>
                </div>
                <div class="botcard-bd">
                  <div>{{ car.carID }}</div>
                  <div>{{ getCarStatus(car.count) }}</div>
                </div>
                <div class="prog">
                  <div :style="{ width: getProgressWidth(car.count) }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 个人中心内容 -->
        <div v-if="showProfile && !iframeMode" id="profileContainer">
          <Profile 
            :user-info="userInfo" 
            @back="closeProfile" 
            @change-password="openChangePasswordModal"
            @logout="openLogoutModal"
          />
        </div>

        <!-- iframe内容容器 -->
        <div v-if="iframeMode" id="iframeContainer" class="iframe-fullheight">
          <iframe 
            :src="iframeUrl" 
            style="width:100%;height:100%;border:2px solid rgba(0,0,0,0.05);border-radius:16px;background:#fff"
          ></iframe>
        </div>
      </main>
    </div>

    <!-- 兑换码弹窗 -->
    <ExchangeModal
      :is-visible="showExchangeModal"
      :user-info="userInfo"
      @close="closeExchangeModal"
      @exchange="loadUserInfo"
    />

    <!-- 修改密码弹窗 -->
    <ChangePasswordModal
      :is-visible="showChangePasswordModal"
      :user-info="userInfo"
      @close="closeChangePasswordModal"
      @success="loadUserInfo"
    />

    <!-- 新PLUS站确认弹窗 -->
    <div v-if="showNewPlusSiteModal" class="modal-overlay" @click="closeNewPlusSiteModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <h3>前往新PLUS站</h3>
          <button class="modal-close" @click="closeNewPlusSiteModal">✕</button>
        </div>
        <div class="modal-content">
          <div class="confirm-content">
            <div class="confirm-icon">🚀</div>
            <p class="confirm-message">您确定要前往新PLUS站点吗？</p>
          </div>
        </div>
        <div class="modal-actions">
          <button class="tech-btn secondary" @click="closeNewPlusSiteModal">取消</button>
          <button class="tech-btn primary" @click="confirmGoToNewPlusSite">确认前往</button>
        </div>
      </div>
    </div>

    <!-- 微信浏览器强制拦截弹窗 -->
    <div v-if="showWechatWarning" class="modal-overlay wechat-warning-overlay">
      <div class="modal-container wechat-warning-modal" @click.stop>
        <div class="modal-content">
          <div class="confirm-content">
            <div class="confirm-icon">🚫</div>
            <p class="confirm-message">禁止在微信中使用</p>
            <p class="confirm-submessage">请复制链接到浏览器（如：Chrome、Safari、Edge）中打开</p>
            <div class="wechat-guide">
              <p class="guide-step">📱 操作步骤：</p>
              <p class="guide-step">1. 点击右上角 "..." 按钮</p>
              <p class="guide-step">2. 选择"在浏览器中打开"</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getConfig, getUserInfo, getCarList, getGrokCarList, getGeminiCarList } from '../api/home'
import { loginSession } from '../api/auth'
import { OAUTH_URL, OAUTH_URL1, OAUTH_URL2 } from '../api/config'
import ExchangeModal from './ExchangeModal.vue'
import ChangePasswordModal from './ChangePasswordModal.vue'
import Profile from './Profile.vue'
import toast from '../utils/toast'

export default {
  name: 'CarList',
  components: { ExchangeModal, ChangePasswordModal, Profile },
  setup() {
    const router = useRouter()
    
    const config = reactive({
      siteName: '',
      siteLogo: '',
      chatgptMenuName: '',
      chatgptNormalName: '',
      chatgptPlusName: '',
      chatgptProName: '',
      chatgptTeamName: '',
      grokMenuName: '',
      grokCarName: '',
      grokSuperName: '',
      geminiMenuName: '',
      geminiCarName: '',
      geminiProCarName: '',
      geminiUltraCarName: '',
      exchangeName: '',
      customMenuConfig: '[]'
    })

    const userInfo = reactive({
      email: '',
      expireTime: '未知',
      grokExpireTime: '未知',
      geminiExpireTime: '未知',
      userToken: ''
    })

    const currentCategory = ref(localStorage.getItem('currentCategory') || 'chatgpt')
    const allCars = ref([])
    const carNotice = ref('')
    const searchKeyword = ref('')
    const isLoggedIn = ref(false) // 是否已登录
    const showProfile = ref(false)
    const showExchangeModal = ref(false)
    const showChangePasswordModal = ref(false)
    const showNewPlusSiteModal = ref(false)
    const showWechatWarning = ref(false) // 微信浏览器警告
    const isLoadingCars = ref(false) // 车队加载状态
    const isPageLoading = ref(true) // 页面加载状态（getConfig）
    const isJoiningCar = ref(false) // 进入车队加载状态
    
    // iframe 相关
    const iframeMode = ref(false)
    const iframeUrl = ref('')
    const iframeTitle = ref('')
    const currentMenuId = ref('')

    // 自定义菜单
    const customMenus = computed(() => {
      try {
        const menus = JSON.parse(config.customMenuConfig || '[]')
        return menus.filter(m => m.enabled)
      } catch (e) {
        return []
      }
    })

    // 图标映射
    const iconMap = {
      'icon-discover': '<svg viewBox="0 0 24 24"><path d="M12 1l3 6 6 .9-4.5 4.4 1 6.2L12 16l-5.5 2.5 1-6.2L3 7.9 9 7z"/></svg>',
      'icon-pending': '<svg viewBox="0 0 24 24"><path d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 5v5l4 2"/></svg>',
      'icon-app': '<svg viewBox="0 0 24 24"><path d="M7 2h10v20H7zM4 6h3v12H4zm13 0h3v12h-3z"/></svg>',
      'icon-goods': '<svg viewBox="0 0 24 24"><path d="M12 8a4 4 0 100 8 4 4 0 000-8zm0-6a2 2 0 110 4 2 2 0 010-4zM4 12a2 2 0 114 0 2 2 0 01-4 0zm12 0a2 2 0 114 0 2 2 0 01-4 0z"/></svg>',
      'default': '<svg viewBox="0 0 24 24"><path d="M4 3h16v14H4zM2 19h20v2H2z"/></svg>'
    }

    const getIconSvg = (iconName) => {
      return iconMap[iconName] || iconMap['default']
    }

    // 获取分类图标
    const getCategoryIcon = (type) => {
      if (type === 'chatgpt') {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" style="width:100%;height:100%;fill:currentColor;">
          <path d="M 14.070312 2 C 11.330615 2 8.9844456 3.7162572 8.0390625 6.1269531 C 6.061324 6.3911222 4.2941948 7.5446684 3.2773438 9.3066406 C 1.9078196 11.678948 2.2198602 14.567816 3.8339844 16.591797 C 3.0745422 18.436097 3.1891418 20.543674 4.2050781 22.304688 C 5.5751778 24.677992 8.2359331 25.852135 10.796875 25.464844 C 12.014412 27.045167 13.895916 28 15.929688 28 C 18.669385 28 21.015554 26.283743 21.960938 23.873047 C 23.938676 23.608878 25.705805 22.455332 26.722656 20.693359 C 28.09218 18.321052 27.78014 15.432184 26.166016 13.408203 C 26.925458 11.563903 26.810858 9.4563257 25.794922 7.6953125 C 24.424822 5.3220082 21.764067 4.1478652 19.203125 4.5351562 C 17.985588 2.9548328 16.104084 2 14.070312 2 z M 14.070312 4 C 15.226446 4 16.310639 4.4546405 17.130859 5.2265625 C 17.068225 5.2600447 17.003357 5.2865019 16.941406 5.3222656 L 12.501953 7.8867188 C 12.039953 8.1527187 11.753953 8.6456875 11.751953 9.1796875 L 11.724609 15.146484 L 9.5898438 13.900391 L 9.5898438 8.4804688 C 9.5898438 6.0104687 11.600312 4 14.070312 4 z M 20.492188 6.4667969 C 21.927441 6.5689063 23.290625 7.3584375 24.0625 8.6953125 C 24.640485 9.696213 24.789458 10.862812 24.53125 11.958984 C 24.470201 11.920997 24.414287 11.878008 24.351562 11.841797 L 19.910156 9.2773438 C 19.448156 9.0113437 18.879016 9.0103906 18.416016 9.2753906 L 13.236328 12.236328 L 13.248047 9.765625 L 17.941406 7.0546875 C 18.743531 6.5915625 19.631035 6.4055313 20.492188 6.4667969 z M 7.5996094 8.2675781 C 7.5972783 8.3387539 7.5898438 8.4087418 7.5898438 8.4804688 L 7.5898438 13.607422 C 7.5898438 14.141422 7.8729844 14.635297 8.3339844 14.904297 L 13.488281 17.910156 L 11.34375 19.134766 L 6.6484375 16.425781 C 4.5094375 15.190781 3.7747656 12.443687 5.0097656 10.304688 C 5.5874162 9.3043657 6.522013 8.5923015 7.5996094 8.2675781 z M 18.65625 10.865234 L 23.351562 13.574219 C 25.490562 14.809219 26.225234 17.556313 24.990234 19.695312 C 24.412584 20.695634 23.477987 21.407698 22.400391 21.732422 C 22.402722 21.661246 22.410156 21.591258 22.410156 21.519531 L 22.410156 16.392578 C 22.410156 15.858578 22.127016 15.364703 21.666016 15.095703 L 16.511719 12.089844 L 18.65625 10.865234 z M 15.009766 12.947266 L 16.78125 13.980469 L 16.771484 16.035156 L 14.990234 17.052734 L 13.21875 16.017578 L 13.228516 13.964844 L 15.009766 12.947266 z M 18.275391 14.853516 L 20.410156 16.099609 L 20.410156 21.519531 C 20.410156 23.989531 18.399687 26 15.929688 26 C 14.773554 26 13.689361 25.54536 12.869141 24.773438 C 12.931775 24.739955 12.996643 24.713498 13.058594 24.677734 L 17.498047 22.113281 C 17.960047 21.847281 18.246047 21.354312 18.248047 20.820312 L 18.275391 14.853516 z M 16.763672 17.763672 L 16.751953 20.234375 L 12.058594 22.945312 C 9.9195938 24.180312 7.1725 23.443687 5.9375 21.304688 C 5.3595152 20.303787 5.2105423 19.137188 5.46875 18.041016 C 5.5297994 18.079003 5.5857129 18.121992 5.6484375 18.158203 L 10.089844 20.722656 C 10.551844 20.988656 11.120984 20.989609 11.583984 20.724609 L 16.763672 17.763672 z"></path>
        </svg>`
      } else if (type === 'grok') {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style="width:100%;height:100%;fill:currentColor;">
          <path d="M 47.658203 2.0566406 C 47.415078 2.0662656 47.174734 2.1631563 46.990234 2.3476562 L 40.880859 8.4648438 C 40.833859 8.4968438 40.789047 8.5351719 40.748047 8.5761719 L 19.146484 30.304688 C 18.777484 30.675688 18.755656 31.266109 19.097656 31.662109 C 19.440656 32.058109 20.027219 32.1245 20.449219 31.8125 L 35.529297 20.667969 C 35.657297 20.572969 35.818125 20.540172 35.953125 20.576172 C 36.101125 20.617172 36.145156 20.725719 36.160156 20.761719 C 37.941156 25.057719 36.981844 29.949656 33.714844 33.222656 C 30.821844 36.118656 26.849547 37.186391 22.810547 36.150391 C 22.575547 36.090391 22.321516 36.119422 22.103516 36.232422 L 16.794922 38.984375 C 16.467922 39.153375 16.259906 39.489422 16.253906 39.857422 C 16.247906 40.225422 16.445625 40.566094 16.765625 40.746094 C 19.618625 42.341094 22.706953 43.119141 25.751953 43.119141 C 30.372953 43.119141 34.89475 41.326094 38.34375 37.871094 C 42.74375 33.467094 44.536297 27.227297 43.154297 21.154297 C 43.150297 21.114297 43.142812 21.073203 43.132812 21.033203 C 41.376812 13.469203 43.505828 10.537469 48.173828 4.1054688 L 48.507812 3.640625 C 48.813813 3.217625 48.741703 2.6309688 48.345703 2.2929688 C 48.147703 2.1249687 47.901328 2.0470156 47.658203 2.0566406 z M 25.996094 7.1367188 C 21.206724 7.0397839 16.477547 8.8765469 12.935547 12.419922 C 7.8695469 17.492922 6.2917656 25.345937 9.0097656 31.960938 C 10.693766 36.058937 7.9562031 38.935484 4.7832031 42.271484 C 3.6512031 43.460484 2.4804844 44.691719 1.5214844 46.011719 C 1.2224844 46.425719 1.2801563 46.998797 1.6601562 47.341797 C 1.8501562 47.513797 2.0900781 47.599609 2.3300781 47.599609 C 2.5680781 47.599609 2.8080469 47.515703 2.9980469 47.345703 L 17.335938 34.525391 C 17.482938 34.416391 17.599922 34.268797 17.669922 34.091797 C 17.822922 33.712797 17.728594 33.278094 17.433594 32.996094 C 14.748594 30.429094 14.157766 27.483844 14.134766 25.464844 C 14.099766 22.358844 15.354984 19.296453 17.583984 17.064453 C 20.080984 14.562453 23.836578 13.331469 27.392578 13.855469 C 27.595578 13.883469 27.810047 13.850906 27.998047 13.753906 L 33.689453 10.800781 C 34.024453 10.627781 34.232516 10.278391 34.228516 9.9003906 C 34.224516 9.5223906 34.006016 9.1796719 33.666016 9.0136719 C 33.269016 8.8206719 32.857031 8.6362812 32.457031 8.4882812 C 30.361094 7.6242188 28.17308 7.18078 25.996094 7.1367188 z"></path>
        </svg>`
      } else {
        // gemini
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="width:100%;height:100%;fill:currentColor;">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"></path>
        </svg>`
      }
    }

    // 获取徽章类型
    const getBadgeType = (car, type) => {
      if (type === 'chatgpt') {
        return car.isPro ? 'PRO' : car.isTeam ? 'TEAM' : car.isPlus ? 'PLUS' : '4o'
      } else if (type === 'grok') {
        return car.isSuperPro ? 'SuperPro' : car.isSuper ? 'Super' : '普号'
      } else {
        // gemini
        return car.isUltra ? 'ULTRA' : car.isPro ? 'PRO' : '普号'
      }
    }

    // 根据 count 获取车队状态
    const getCarStatus = (count) => {
      const num = Number(count) || 0
      if (num <= 30) return '空闲'
      if (num <= 60) return '正常'
      return '繁忙'
    }

    // 获取进度条宽度
    const getProgressWidth = (count) => {
      const num = Number(count) || 0
      if (num <= 30) return '5%'
      if (num <= 60) return '20%'
      return '60%'
    }

    // 格式化过期时间显示
    const formatExpireTime = (expireTime) => {
      if (!expireTime || expireTime === '未知') return '无有效订阅'
      return expireTime
    }

    // 计算显示的分类（根据搜索关键词过滤）
    const displayCategories = computed(() => {
      const keyword = searchKeyword.value.toLowerCase().trim()
      const categories = []

      if (currentCategory.value === 'chatgpt') {
        // PRO
        if (config.chatgptProName && config.chatgptProName.trim() !== '') {
          const proCars = allCars.value.filter(car => car.isPro)
          const filteredCars = keyword 
            ? proCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : proCars
          if (filteredCars.length > 0) {
            categories.push({ key: 'pro', name: config.chatgptProName, cars: filteredCars, type: 'chatgpt' })
          }
        }
        
        // TEAM
        const teamCars = allCars.value.filter(car => car.isTeam)
        const filteredTeamCars = keyword 
          ? teamCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : teamCars
        if (filteredTeamCars.length > 0) {
          categories.push({ key: 'team', name: config.chatgptTeamName, cars: filteredTeamCars, type: 'chatgpt' })
        }
        
        // PLUS
        const plusCars = allCars.value.filter(car => car.isPlus && !car.isTeam && !car.isPro)
        const filteredPlusCars = keyword 
          ? plusCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : plusCars
        if (filteredPlusCars.length > 0) {
          categories.push({ key: 'plus', name: config.chatgptPlusName, cars: filteredPlusCars, type: 'chatgpt' })
        }
        
        // NORMAL
        const normalCars = allCars.value.filter(car => !car.isPlus && !car.isPro && !car.isTeam)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.chatgptNormalName, cars: filteredNormalCars, type: 'chatgpt' })
        }
      } else if (currentCategory.value === 'grok') {
        // Super
        const superCars = allCars.value.filter(car => car.isSuper || car.isSuperPro)
        const filteredSuperCars = keyword 
          ? superCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : superCars
        if (filteredSuperCars.length > 0) {
          categories.push({ key: 'super', name: config.grokSuperName, cars: filteredSuperCars, type: 'grok' })
        }
        
        // Normal
        const normalCars = allCars.value.filter(car => !car.isSuper && !car.isSuperPro)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.grokCarName, cars: filteredNormalCars, type: 'grok' })
        }
      } else if (currentCategory.value === 'gemini') {
        // Ultra
        if (config.geminiUltraCarName && config.geminiUltraCarName.trim() !== '') {
          const ultraCars = allCars.value.filter(car => car.isUltra)
          const filteredUltraCars = keyword 
            ? ultraCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : ultraCars
          if (filteredUltraCars.length > 0) {
            categories.push({ key: 'ultra', name: config.geminiUltraCarName, cars: filteredUltraCars, type: 'gemini' })
          }
        }
        
        // PRO
        if (config.geminiProCarName && config.geminiProCarName.trim() !== '') {
          const proCars = allCars.value.filter(car => car.isPro && !car.isUltra)
          const filteredCars = keyword 
            ? proCars.filter(car => car.carID.toLowerCase().includes(keyword))
            : proCars
          if (filteredCars.length > 0) {
            categories.push({ key: 'pro', name: config.geminiProCarName, cars: filteredCars, type: 'gemini' })
          }
        }
        
        // Normal
        const normalCars = allCars.value.filter(car => !car.isPro && !car.isUltra)
        const filteredNormalCars = keyword 
          ? normalCars.filter(car => car.carID.toLowerCase().includes(keyword))
          : normalCars
        if (filteredNormalCars.length > 0) {
          categories.push({ key: 'normal', name: config.geminiCarName, cars: filteredNormalCars, type: 'gemini' })
        }
      }

      return categories
    })

    // 检查是否有 share-session cookie
    const hasShareSession = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session' && value && value.trim() !== '') {
          return true
        }
      }
      return false
    }

    // 获取 share-session cookie 的值
    const getShareSessionValue = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session') {
          return value || ''
        }
      }
      return ''
    }

    // 加载配置
    const loadConfig = async () => {
      isPageLoading.value = true
      try {
        const res = await getConfig()
        if (res.code === 1 && res.data) {
          Object.assign(config, res.data)
        }
      } catch (error) {
        console.error('加载配置失败:', error)
      } finally {
        isPageLoading.value = false
      }
    }

    // 加载用户信息
    const loadUserInfo = async () => {
      const sessionValue = getShareSessionValue()
      console.log('🔍 当前 share-session cookie 值:', sessionValue ? '有值' : '无值或空值')

      // 只有存在 share-session cookie 时才请求用户信息
      if (!hasShareSession()) {
        console.log('❌ 未检测到有效的 share-session cookie，跳过用户信息请求')
        isLoggedIn.value = false
        return
      }

      console.log('✅ 检测到有效的 share-session cookie，开始请求用户信息')

      try {
        const res = await getUserInfo()
        console.log('📡 getUserInfo 响应:', res)

        if (res.code === 1 && res.data) {
          console.log('📋 用户数据详情:', res.data)

          // 判断是否为游客
          // 游客返回: {"code":1,"data":{"name":"游客"}}
          // 用户返回: {"code":1,"data":{"email":"...","expireTime":"...","userToken":"..."}}
          if (res.data.name === '游客') {
            console.log('👤 用户状态：游客或无效用户')
            isLoggedIn.value = false
          } else {
            console.log('✅ 用户状态：已登录', res.data.userToken)
            isLoggedIn.value = true
            Object.assign(userInfo, res.data)
          }
        } else {
          console.log('❌ API返回码非1:', res.code, res.msg || '无消息')
          isLoggedIn.value = false
        }
      } catch (error) {
        console.error('❌ 加载用户信息失败:', error)
        isLoggedIn.value = false
      }
    }

    // 加载车队列表
    const loadCarList = async () => {
      try {
        const res = currentCategory.value === 'chatgpt'
          ? await getCarList()
          : currentCategory.value === 'grok'
          ? await getGrokCarList()
          : await getGeminiCarList()

        if (res.code === 1 && res.data) {
          allCars.value = res.data.list || []
          carNotice.value = res.data.notice || ''
        }
      } catch (error) {
        console.error('加载车队列表失败:', error)
      }
    }

    // 切换分类
    const switchCategory = async (category) => {
      if (iframeMode.value) {
        closeIframe()
      }
      // 退出个人中心视图，恢复车队列表
      if (showProfile.value) {
        showProfile.value = false
      }
      
      currentCategory.value = category
      searchKeyword.value = ''
      
      // 保存当前分类到 localStorage
      localStorage.setItem('currentCategory', category)
      
      // 加载车辆列表
      isLoadingCars.value = true
      await loadCarList()
      isLoadingCars.value = false
      
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    // 打开iframe
    const openInIframe = (url, title, id) => {
      // 关闭个人中心
      showProfile.value = false
      iframeMode.value = true
      iframeUrl.value = url
      iframeTitle.value = title
      currentMenuId.value = id
      
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    // 关闭iframe
    const closeIframe = () => {
      iframeMode.value = false
      iframeUrl.value = ''
      iframeTitle.value = ''
      currentMenuId.value = ''
    }

    // 打开个人中心
    const openProfile = () => {
      showProfile.value = true
      iframeMode.value = false
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
    }

    const closeProfile = () => {
      showProfile.value = false
    }

    // 兑换码弹窗
    const openExchangeModal = () => { showExchangeModal.value = true }
    const closeExchangeModal = () => { showExchangeModal.value = false }

    // 处理兑换码
    const handleExchange = () => {
      const code = prompt('请输入兑换码：')
      if (code) {
        alert('兑换功能待实现')
      }
    }

    // 跳转到登录页面
    const goToLogin = () => {
      router.push('/login')
    }

    // 修改密码（打开修改密码弹窗）
    const openChangePasswordModal = () => {
      showChangePasswordModal.value = true
    }
    
    const closeChangePasswordModal = () => {
      showChangePasswordModal.value = false
    }

    // 退出登录（清除 share-session cookie 并跳转到登录页）
    const openLogoutModal = () => {
      // 清除 share-session cookie（尝试多种路径和域名组合）
      const domain = window.location.hostname
      document.cookie = 'share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
      document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`
      document.cookie = `share-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`
      
      // 清除 localStorage 中保存的账号信息
      localStorage.removeItem('savedUsername')
      localStorage.removeItem('savedPassword')
      console.log('🗑️ 已清除所有登录信息')
      
      // 跳转到登录页
      router.push('/login')
    }

    // 获取 share-session cookie 的值
    const getShareSessionCookie = () => {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'share-session') {
          return value
        }
      }
      return ''
    }

    // 打开新PLUS站确认弹窗
    const openNewPlusSiteModal = () => {
      // 关闭移动端侧边栏
      const navToggle = document.getElementById('nav-toggle')
      if (navToggle) navToggle.checked = false
      // 显示弹窗
      showNewPlusSiteModal.value = true
    }

    // 关闭新PLUS站确认弹窗
    const closeNewPlusSiteModal = () => {
      showNewPlusSiteModal.value = false
    }

    // 检测是否为微信浏览器
    const isWechatBrowser = () => {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    }

    // 确认前往新PLUS站
    const confirmGoToNewPlusSite = async () => {
      closeNewPlusSiteModal()
      // 检查 expireTime 是否为空（始终使用GPT的订阅时间）
      const expireTime = userInfo.expireTime
      if (!expireTime || expireTime === '未知') {
        toast.error('无有效订阅，请及时续费！！！')
        return
      }

      // 检查 expireTime 是否大于6小时（使用上海时区时间）
      try {
        const expireDate = new Date(expireTime)
        // 获取上海时区（UTC+8）的当前时间
        const nowUTC = new Date()
        const shanghaiTime = new Date(nowUTC.getTime() + (nowUTC.getTimezoneOffset() * 60000) + (8 * 60 * 60000))
        const diffHours = (expireDate - shanghaiTime) / (1000 * 60 * 60)
        
        if (diffHours < 6) {
          toast.error('会员时长大于6小时方可使用新版PLUS')
          return
        }
      } catch (error) {
        console.error('时间解析错误:', error)
      }

      // 验证通过后显示页面加载状态
      isPageLoading.value = true

      const shareToken = getShareSessionCookie()
      

      // 快速测试 OAUTH_URL1 和 OAUTH_URL2 是否返回 200 状态码
      let targetUrl = OAUTH_URL
      
      // 测试 OAUTH_URL1
      try {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 1500)
        
        const testResponse = await fetch(`${OAUTH_URL1}status`, {
          method: 'HEAD',
          mode: 'cors',
          cache: 'no-cache',
          signal: controller.signal
        })
        
        clearTimeout(timeoutId)
        
        if (testResponse.status === 200) {
          targetUrl = OAUTH_URL1
          console.log('✅ OAUTH_URL1 状态检查通过(200)，使用站点1')
        } else {
          throw new Error(`状态码: ${testResponse.status}`)
        }
      } catch (error) {
        console.log('❌ OAUTH_URL1 不可达 (' + (error.name === 'AbortError' ? '超时' : error.message) + ') → 尝试 OAUTH_URL2')
        
        // 测试 OAUTH_URL2
        try {
          const controller2 = new AbortController()
          const timeoutId2 = setTimeout(() => controller2.abort(), 1000)
          
          const testResponse2 = await fetch(`${OAUTH_URL2}status`, {
            method: 'HEAD',
            mode: 'cors',
            cache: 'no-cache',
            signal: controller2.signal
          })
          
          clearTimeout(timeoutId2)
          
          if (testResponse2.status === 200) {
            targetUrl = OAUTH_URL2
            console.log('✅ OAUTH_URL2 状态检查通过(200)，使用站点2')
          } else {
            throw new Error(`状态码: ${testResponse2.status}`)
          }
        } catch (error2) {
          // 两个都不可达，使用备用站点
          console.log('❌ OAUTH_URL2 不可达 (' + (error2.name === 'AbortError' ? '超时' : error2.message) + ') → 使用备用站点')
        }
      }
      
      const url = `${targetUrl}loading?sharetoken=${shareToken}&url=${encodeURIComponent(targetUrl)}&share_url=${encodeURIComponent(window.location.href)}`
      window.location.href = url
    }

    // 处理车对卡片点击
    const handleCarClick = async (carID, carType) => {  
      console.log(`🚗 点击车队卡片: ${carID}, 类型: ${carType}`)
      
      // 检查是否有 share-session cookie
      if (!hasShareSession()) {
        console.log('❌ 未检测到 share-session，跳转登录页')
        toast.info('请登录')
        router.push('/login')
        return
      }

      // 检查 expireTime 是否为空
      const expireTime = carType === 'grok' 
        ? userInfo.grokExpireTime 
        : carType === 'gemini' 
        ? userInfo.geminiExpireTime 
        : userInfo.expireTime
      if (!expireTime || expireTime === '未知') {
        toast.error('无有效订阅，请及时续费！！！')
        return
      }

      try {
        // 显示加载效果
        isJoiningCar.value = true
        console.log('📡 调用 loginSession 接口...')
        
        const res = await loginSession({
          carid: carID,
          carType: carType
        })
        
        console.log('📡 loginSession 响应:', res)

        // 检查成功响应：code = 1 就是接口成功
        if (res.code === 1) {
          // Gemini 车队跳转到 /app，其他车队跳转到根路径
          const targetPath = carType === 'gemini' ? '/app' : '/'
          console.log(`✅ 登录会话成功，跳转到 ${targetPath}`)
          // 跳转前不关闭加载，保持加载状态直到页面跳转完成
          window.location.href = window.location.origin + targetPath
          return
        }

        // 其他情况根据 code 处理
        isJoiningCar.value = false
        console.log('❌ 登录会话失败:', res.msg)
        
        if (res.code === 0) {
          // 特殊情况：其他设备登录，需要跳转到登录页
          if (res.msg && res.msg.includes('其他设备登陆')) {
            toast.error(res.msg)
            router.push('/login')
          } else {
            // 其他 code === 0 的情况只提示错误信息
            toast.error(res.msg || '操作失败')
          }
        } else {
          // 其他情况（如 code === -1）才跳转登录
          toast.error(res.msg || '登录失败')
          router.push('/login')
        }
      } catch (error) {
        // 关闭加载效果
        isJoiningCar.value = false
        console.error('❌ 点击车队卡片失败:', error)
        
        // 处理网络错误或其他异常
        if (error.response && error.response.data) {
          const errorData = error.response.data
          if (errorData.code === -1) {
            toast.error(errorData.msg || '登录失败')
            router.push('/login')
            return
          }
          // code === 0 只提示错误信息
          if (errorData.code === 0) {
            toast.error(errorData.msg || '操作失败')
            return
          }
        }
        
        toast.error('操作失败，请稍后重试')
      }
    }

    // 初始化
    onMounted(async () => {
      try {
        console.log('🚀 开始初始化页面...')
        
        // 检测微信浏览器
        if (isWechatBrowser()) {
          console.log('⚠️ 检测到微信浏览器，显示警告')
          showWechatWarning.value = true
        }
        
        // 设置加载状态
        isLoadingCars.value = true

        // 步骤1：检测并获取用户信息（getme）
        if (hasShareSession()) {
          console.log('👤 步骤1: 检测到有效cookie，开始获取用户信息')
          await loadUserInfo()
          console.log('✅ 用户信息加载完成')
        } else {
          console.log('👤 步骤1: 无有效cookie，跳过用户信息获取')
          isLoggedIn.value = false
        }

        // 步骤2：加载配置（getConfig）
        console.log('📋 步骤2: 加载配置信息')
        await loadConfig()
        console.log('✅ 配置加载完成')

        // 步骤3：加载车辆列表（carpage）
        console.log('🚗 步骤3: 加载车辆列表')
        await loadCarList()
        console.log('✅ 车辆列表加载完成')

      } catch (error) {
        console.error('❌ 初始化失败:', error)
      } finally {
        // 所有接口加载完成后关闭加载动画
        console.log('🏁 所有接口加载完成，关闭加载动画')
        isLoadingCars.value = false
      }
    })

    return {
      config,
      userInfo,
      currentCategory,
      allCars,
      carNotice,
      searchKeyword,
      displayCategories,
      customMenus,
      iframeMode,
      iframeUrl,
      iframeTitle,
      currentMenuId,
      isLoggedIn,
      showProfile,
      showExchangeModal,
      showChangePasswordModal,
      showNewPlusSiteModal,
      showWechatWarning,
      isLoadingCars,
      isPageLoading,
      isJoiningCar,
      getIconSvg,
      getCategoryIcon,
      getBadgeType,
      getCarStatus,
      getProgressWidth,
      formatExpireTime,
      switchCategory,
      openInIframe,
      closeIframe,
      openProfile,
      closeProfile,
      openExchangeModal,
      closeExchangeModal,
      handleExchange,
      goToLogin,
      openChangePasswordModal,
      closeChangePasswordModal,
      openLogoutModal,
      openNewPlusSiteModal,
      closeNewPlusSiteModal,
      confirmGoToNewPlusSite,
      handleCarClick,
      loadUserInfo
    }
  }
}
</script>

<style>
/* 使用全局样式而不是 scoped，确保所有样式正确应用 */
:root{
  --bg:#fff;--text:#1f1f23;--muted:#7a7a85;--line:#ececf0;--purple:#7b5cff;
  --brand-grad:linear-gradient(141deg, rgba(191,102,255,1) 0%, rgba(98,72,255,1) 50%, rgba(0,221,235,1) 100%);
  --shadow:0 8px 24px rgba(34,27,62,.08);--green:#1acc5a;--notice:#ff4d4f;
  --r-pill:30px;--r-card:20px
}
*{box-sizing:border-box;margin:0;padding:0}
html{scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none}
html::-webkit-scrollbar{display:none}
body{background:var(--bg);font-family:"Poppins","Microsoft YaHei",sans-serif;color:var(--text);overflow-x:hidden;scrollbar-width:none;-ms-overflow-style:none}
body::-webkit-scrollbar{display:none}
#nav-toggle{display:none}
.page{display:grid;grid-template-columns:200px 1fr;gap:12px;min-height:100vh;padding:12px}

/* 侧边栏 */
.sidebar{display:flex;flex-direction:column;gap:10px;transition:transform .3s ease;z-index:1001;height:calc(100vh - 24px);position:sticky;top:12px}
.side-box{background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-card);box-shadow:0 4px 12px rgba(0,0,0,.05);padding:14px}
.side-box:last-child{flex:1;display:flex;flex-direction:column;overflow:hidden}
.side-brand{display:flex;align-items:center;justify-content:center;gap:10px}
.side-brand svg{width:24px;height:24px;fill:currentColor}
.side-brand img{width:24px;height:24px;border-radius:6px;object-fit:cover}
.nav{display:flex;flex-direction:column;gap:12px;flex:1;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}
.nav::-webkit-scrollbar{display:none}
.nav-item{display:flex;align-items:center;justify-content:flex-start;padding:10px 12px;border:2px solid var(--line);border-radius:14px;background:#fff;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);will-change:transform,box-shadow;font-weight:600}
.nav-item:hover{border-color:var(--purple);box-shadow:0 6px 16px rgba(123,92,255,0.2);transform:translateX(4px)}
.nav-item:active{transform:translateX(2px) scale(0.98)}
.nav-item.active{border-color:var(--purple);background:var(--brand-grad);color:#fff;box-shadow:0 4px 12px rgba(123,92,255,0.3)}

/* 主体列 */
.main{display:flex;flex-direction:column;gap:10px}

/* 顶部栏 */
.page-header{display:flex;justify-content:space-between;align-items:center;background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-pill);padding:8px 12px;box-shadow:var(--shadow)}
.sys{display:none;align-items:center;gap:10px}
.sys svg{width:22px;height:22px}
.redeem{display:flex;align-items:center;gap:10px;justify-content:flex-end;flex:1}
.action-buttons{display:flex;gap:6px;align-items:center}
.btn-redeem{border:2px dashed var(--notice);color:var(--notice);padding:5px 10px;border-radius:12px;background:#fff;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);will-change:transform}
.btn-redeem:hover{background:#fff1f0;border-color:#ff7875;transform:translateY(-2px);box-shadow:0 4px 12px rgba(255,77,79,0.2)}
.btn-redeem:active{transform:translateY(0)}
.btn-plus{border:2px solid var(--purple);color:#fff;background:var(--brand-grad);padding:5px 10px;border-radius:12px;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);box-shadow:0 4px 12px rgba(123,92,255,0.3);will-change:transform}
.btn-plus:hover{transform:translateY(-3px);box-shadow:0 8px 20px rgba(123,92,255,0.5)}
.btn-plus:active{transform:translateY(-1px)}
.btn-login{border:2px solid var(--purple);color:#fff;background:var(--brand-grad);padding:6px 20px;border-radius:12px;font-weight:700;font-size:14px;white-space:nowrap;cursor:pointer;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);box-shadow:0 4px 12px rgba(123,92,255,0.3);will-change:transform}
.btn-login:hover{transform:translateY(-3px);box-shadow:0 8px 20px rgba(123,92,255,0.5)}
.btn-login:active{transform:translateY(-1px)}
.userpill{display:flex;align-items:center;justify-content:center;gap:8px;border:2px solid #ddd;border-radius:12px;padding:5px 8px;white-space:nowrap}
.brand{display:flex;align-items:center;gap:8px}
.brand svg{width:22px;height:22px}

.notice.box{text-align:center;font-family:"KaiTi",serif;font-weight:700;color:#222;border:2px solid #000}
.box{background:#fff;border:2px solid rgba(0,0,0,.05);border-radius:var(--r-card);padding:12px;box-shadow:0 4px 12px rgba(0,0,0,.05)}

.fleet-toolbar{display:flex;justify-content:flex-start;align-items:center;gap:8px;flex-wrap:nowrap}
.search{display:flex;align-items:center;gap:6px;border:2px solid var(--line);border-radius:999px;padding:6px 10px;background:#fff;flex:1 1 auto;max-width:372px;min-width:100px}
.search input{border:0;outline:0;font-weight:700;width:100%;min-width:0}

/* 快捷导航 */
.quick-nav{display:flex;gap:6px}
.quick-nav-btn{display:flex;align-items:center;gap:4px;padding:6px 12px;border:2px solid var(--line);border-radius:12px;background:#fff;cursor:pointer;font-weight:700;font-size:14px;color:#666;transition:all 0.3s cubic-bezier(0.4, 0, 0.2, 1);white-space:nowrap;will-change:transform}
.quick-nav-btn:hover{border-color:var(--purple);background:#f6f4ff;color:var(--purple);transform:translateY(-2px);box-shadow:0 4px 12px rgba(123,92,255,0.15)}
.quick-nav-btn:active{transform:translateY(0)}
.quick-nav-btn.active{border-color:var(--purple);background:var(--brand-grad);color:#fff;box-shadow:0 4px 12px rgba(123,92,255,0.3)}
.quick-nav-btn.active svg{fill:#fff}
.quick-nav-btn svg{transition:fill 0.3s}

/* 返回按钮 */
.back-btn{padding:8px 16px;border:2px solid var(--line);border-radius:12px;background:#fff;cursor:pointer;font-weight:700;display:flex;align-items:center;gap:6px;transition:all 0.3s;font-size:14px;color:#333}
.back-btn:hover{border-color:var(--purple);background:#f6f4ff;color:var(--purple);transform:translateX(-2px)}

/* 车队分类区域 */
.category-section{margin-bottom:16px}
.category-title{font-size:20px;font-weight:900;color:#1f1f23;margin-bottom:10px;display:flex;align-items:center;gap:8px}

.fleet-content{display:grid;grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:12px}
.botcard{background:#fff;border:3px solid rgba(123,92,255,0.4);border-radius:20px;box-shadow:0 8px 30px rgba(0,0,0,0.2);height:auto;min-height:120px;display:flex;flex-direction:column;backdrop-filter:blur(6px);transition:all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);overflow:hidden;will-change:transform;cursor:pointer}
.botcard:hover{transform:translateY(-8px) scale(1.02);box-shadow:0 16px 48px rgba(123,92,255,0.4);border-color:#7b5cff}
.botcard-hd{background:#fff;padding:12px 14px;display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #ececec;flex-shrink:0;color:#333;font-weight:700}
.botcard-hd > span{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;color:#7b5cff}
.botcard-hd > span svg{display:block;width:100%;height:100%}
.badge-container{display:flex;gap:6px;align-items:center}
.badge{background:linear-gradient(141deg,rgba(191,102,255,1) 0%,rgba(98,72,255,1) 50%,rgba(0,221,235,1) 100%);color:#fff;padding:6px 12px;border-radius:14px;font-size:12px;box-shadow:0 2px 6px rgba(123,92,255,0.4);transition:transform 0.2s ease,box-shadow 0.3s ease;cursor:pointer}
.badge:hover{transform:scale(1.08);box-shadow:0 4px 10px rgba(0,0,0,0.25)}
.recommend-badge{background:linear-gradient(135deg,#ff6b6b,#ff8e53);color:#fff;padding:4px 10px;border-radius:12px;font-size:11px;font-weight:700;box-shadow:0 2px 6px rgba(255,107,107,0.4);animation:pulse-glow 2s ease-in-out infinite}
.botcard-bd{padding:14px 16px;display:flex;justify-content:space-between;flex:1;align-items:center;font-size:14px;font-weight:900;color:#222;letter-spacing:0.3px}
.botcard-bd > div:first-child{font-size:17px;font-weight:900}
.botcard-bd > div:last-child{color:#555;font-size:14px;font-weight:700}
.prog{height:9px;background:#f3f3f3;margin:0 14px 12px;border-radius:999px;flex-shrink:0;overflow:hidden}
.prog div{height:100%;width:30%;background:linear-gradient(90deg,#7b5cff,#3aa0ff);border-radius:999px;box-shadow:0 0 10px rgba(123,92,255,0.5);transition:width 0.8s cubic-bezier(0.4, 0, 0.2, 1)}

/* 移动端 */
.hamburger{display:none}
.drawer-mask{display:none}
.close-btn{display:none}

/* 中等屏幕适配 (1000px以下) */
@media(max-width:1000px){
  .page-header{flex-wrap:wrap;gap:8px}
  .redeem{flex-direction:column;align-items:stretch;gap:8px;width:100%}
  .action-buttons{flex-direction:row;justify-content:center;gap:6px;width:100%}
  .btn-redeem,.btn-plus{flex:1;white-space:nowrap;min-width:0}
  .userpill{flex-wrap:wrap;justify-content:center;width:100%}
  .userpill > div:first-child{flex:0 0 100%;text-align:center;margin-bottom:4px}
  .userpill small{flex:0 0 100%;text-align:center;margin-left:0}
}

@media(max-width:768px){
  .page{grid-template-columns:1fr;position:relative;overflow:hidden;padding:8px}
  .hamburger{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border:2px solid var(--line);border-radius:10px;background:#fff;cursor:pointer;font-size:20px;line-height:1}
  
  .sys{display:flex;justify-content:space-between;align-items:center;order:1}
  .brand{display:flex;justify-content:center;flex:1}
  .hamburger{margin-right:auto}
  
  .page-header{flex-direction:column;gap:8px}
  .redeem{width:100%;justify-content:space-between;flex-wrap:wrap}
  
  .fleet-toolbar{gap:6px;flex-wrap:nowrap}
  .search{flex:1 1 auto;min-width:80px;max-width:none}
  .quick-nav{gap:4px;flex-shrink:0}
  .quick-nav-btn{padding:5px 10px;font-size:13px;gap:3px;flex-shrink:0}
  .quick-nav-btn svg{width:16px;height:16px}
  
  .fleet-content{gap:10px;grid-template-columns:repeat(auto-fill,minmax(160px,1fr))}
  .category-title{font-size:18px}
  
  .sidebar{
    position:fixed;
    left:0;
    top:0;
    width:100vw;
    height:auto;
    max-height:80vh;
    background:#fff;
    border-bottom-left-radius:20px;
    border-bottom-right-radius:20px;
    box-shadow:0 12px 40px rgba(0,0,0,0.25);
    padding:18px 14px;
    z-index:1001;
    transform:translateY(-100%);
    pointer-events:none;
    transition:transform 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
    overflow-y:auto;
    scrollbar-width:none;
    -ms-overflow-style:none;
    display:flex;
    flex-direction:column;
    gap:18px;
  }
  
  .sidebar::-webkit-scrollbar{
    display:none;
  }
  
  #nav-toggle:checked ~ .page .sidebar{
    transform:translateY(0);
    pointer-events:auto;
  }
  
  .drawer-mask{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.5);
    backdrop-filter:blur(4px);
    z-index:1000;
    opacity:0;
    pointer-events:none;
    transition:opacity 0.3s ease;
  }
  
  #nav-toggle:checked ~ .page .drawer-mask{
    display:block;
    opacity:1;
    pointer-events:auto;
  }
  
  .close-btn{
    display:block;
    position:absolute;
    top:16px;
    right:16px;
    width:32px;
    height:32px;
    border:none;
    border-radius:50%;
    background:#f5f5f5;
    cursor:pointer;
    font-size:20px;
    line-height:1;
    font-weight:300;
    color:#666;
    z-index:10;
    display:grid;
    place-items:center;
  }
  
  .side-box{
    border:none;
    box-shadow:none;
    background:transparent;
    padding:0;
    margin:0;
  }
  
  .side-box:first-of-type{
    background:transparent;
    padding:0;
    margin-bottom:0;
    border-bottom:none;
  }
  
  .side-box:last-of-type{
    background:transparent;
    padding:0;
    flex:none;
  }
  
  .side-brand{
    margin-top:0;
    justify-content:flex-start;
    padding-bottom:14px;
    border-bottom:1px solid #f0f0f0;
  }
  
  .nav-item{
    background:#f8f9fa;
    border:1px solid #e9ecef;
    border-radius:12px;
    padding:12px 14px;
    justify-content:flex-start;
    transition:all 0.2s ease;
  }
  
  .nav-item:active{
    background:#e9ecef;
    transform:scale(0.98);
  }
  
  .nav-item.active{
    border-color:var(--purple);
    background:var(--brand-grad);
    color:#fff;
  }
  
  .nav-item.active .nav-ico{
    background:rgba(255,255,255,0.2);
  }
  
  .nav-item.active .nav-ico svg{
    fill:#fff;
  }

  .page-header{flex-direction:column;align-items:stretch;gap:8px;padding:10px;border-radius:16px}
  .sys{display:flex;justify-content:space-between;align-items:center;order:1}
  .brand{display:flex;justify-content:center;flex:1}
  .hamburger{margin-right:auto}
  .redeem{flex-direction:column;order:2;gap:6px;justify-content:center}
  .action-buttons{width:100%;display:flex;flex-direction:column;gap:6px}
  .userpill{width:100%;justify-content:center;padding:8px 10px;gap:6px;flex-wrap:wrap;display:flex}
  .userpill > div:first-child{font-weight:700;flex:0 0 100%;text-align:center}
  .userpill small{flex:0 0 100%;text-align:center;font-size:11px;color:var(--muted);margin-left:0}
  .btn-redeem{width:100%;text-align:center;padding:8px 10px;font-size:13px}
  .btn-plus{width:100%;text-align:center;padding:8px 10px;font-size:13px}
  .btn-login{width:100%;text-align:center;padding:10px;font-size:14px}

  .notice.box{font-size:13px;padding:10px;line-height:1.5}
  .fleet-toolbar{flex-direction:row;align-items:center;gap:6px;flex-wrap:nowrap}
  .search{flex:1 1 auto;min-width:80px;max-width:none}
  .search input{font-size:14px;min-width:0}

  .fleet-content{grid-template-columns:repeat(auto-fill,minmax(220px,1fr));gap:10px}
  .botcard{min-height:120px}
  .botcard-hd{padding:10px 12px;font-size:14px}
  .botcard-hd > span{width:26px;height:26px}
  .badge-container{gap:4px;flex-wrap:wrap}
  .badge{padding:4px 10px;font-size:11px}
  .recommend-badge{padding:3px 8px;font-size:10px}
  .botcard-bd{font-size:13px;padding:10px 12px}
  .botcard-bd > div:first-child{font-size:16px}
  .botcard-bd > div:last-child{font-size:13px}
  .prog{margin:0 12px 10px;height:8px}
}

.main{min-width:0}

@media (min-width: 769px) {
  .drawer-mask { display: none !important; pointer-events: none !important; opacity: 0 !important; }
  .close-btn { display: none !important; }
}

@supports not (display: grid) {
  .page { display: flex; gap: 20px; }
  .sidebar { width: 220px; flex: 0 0 220px; }
  .main { flex: 1 1 auto; min-width: 0; }
}

/* 新PLUS站确认弹窗样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
}

.modal-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-content {
  margin-bottom: 24px;
}

.confirm-content {
  text-align: center;
  padding: 20px 0;
}

.confirm-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.confirm-message {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px 0;
}

.confirm-submessage {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.tech-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  min-width: 90px;
}

.tech-btn.secondary {
  background: #fff;
  color: #666;
  border: 1px solid #d9d9d9;
}

.tech-btn.secondary:hover {
  color: #333;
  border-color: #333;
  background: #f5f5f5;
}

.tech-btn.primary {
  background: linear-gradient(135deg, #7b5cff, #9b7bff);
  color: white;
  box-shadow: 0 4px 12px rgba(123, 92, 255, 0.3);
}

.tech-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(123, 92, 255, 0.4);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(50px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 加载动画 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  min-height: 400px;
}

.loading-spinner-large {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(123, 92, 255, 0.1);
  border-radius: 50%;
  border-top-color: #7b5cff;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-text {
  font-size: 16px;
  color: #666;
  font-weight: 600;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes pulse-glow {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 2px 6px rgba(255,107,107,0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255,107,107,0.6);
  }
}

/* iframe 容器样式 */
.iframe-fullheight {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

@media(max-width:768px){
  .iframe-fullheight {
    height: calc(100vh - 120px);
  }
}

/* 全局页面加载 */
.page-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

.page-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.page-loading-spinner {
  width: 80px;
  height: 80px;
  border: 6px solid rgba(123, 92, 255, 0.2);
  border-radius: 50%;
  border-top-color: #7b5cff;
  animation: spin 1s linear infinite;
}

.page-loading-text {
  font-size: 18px;
  color: #666;
  font-weight: 600;
  letter-spacing: 1px;
  animation: pulse 1.5s ease-in-out infinite;
}

/* 微信浏览器强制拦截弹窗 */
.wechat-warning-overlay {
  z-index: 10000;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
}

.wechat-warning-modal {
  border: 4px solid #ff4d4f;
  box-shadow: 0 20px 80px rgba(255, 77, 79, 0.6);
  background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);
  max-width: 500px;
}

.wechat-warning-modal .modal-content {
  padding: 20px 0;
}

.wechat-warning-modal .confirm-icon {
  font-size: 100px;
  animation: pulse-scale 2s ease-in-out infinite;
  filter: drop-shadow(0 4px 12px rgba(255, 77, 79, 0.3));
}

.wechat-warning-modal .confirm-message {
  font-size: 28px;
  color: #ff4d4f;
  font-weight: 900;
  margin: 20px 0 12px 0;
  text-shadow: 0 2px 4px rgba(255, 77, 79, 0.2);
}

.wechat-warning-modal .confirm-submessage {
  font-size: 16px;
  color: #333;
  margin: 12px 0;
  line-height: 1.6;
  font-weight: 600;
}

.wechat-guide {
  margin-top: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #fff9e6 0%, #ffe6e6 100%);
  border-radius: 12px;
  border: 2px dashed #ff8e53;
  text-align: left;
}

.guide-step {
  font-size: 15px;
  color: #333;
  margin: 8px 0;
  font-weight: 600;
  line-height: 1.8;
}

.guide-step:first-child {
  font-size: 17px;
  color: #ff6b6b;
  font-weight: 700;
  margin-bottom: 12px;
}

@keyframes pulse-scale {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

@media(max-width:768px){
  .wechat-warning-modal {
    margin: 0 20px;
  }
  
  .wechat-warning-modal .confirm-icon {
    font-size: 80px;
  }
  
  .wechat-warning-modal .confirm-message {
    font-size: 24px;
  }
  
  .wechat-warning-modal .confirm-submessage {
    font-size: 15px;
  }
  
  .guide-step {
    font-size: 14px;
  }
  
  .guide-step:first-child {
    font-size: 16px;
  }
}
</style>

